<script>
// import store from '../../store.js'
import Vue from 'vue'
import { mapActions } from 'vuex'
import Router from 'vue-router'

Vue.use(Router)

export default {
  render: function (h) {
    return h()
  },
  data () {
    return {
      loadedFiles: {},
      pendingFiles: [],
      pendingFile: null,
      stop: false,
      xhr: null
    }
  },
  props: {
    idx_image: {
      required: true
    },
    idx_esquema: {
      required: true
    },
    vattachments_image: {
      type: Object
    },
    vattachments_esquema: {
      type: Object
    }
  },
  created () {
    for (var i in this.vattachments_image) {
      this.addPendingFile({ idx: this.idx_image, file: i })
    }
    for (i in this.vattachments_esquema) {
      this.addPendingFile({ idx: this.idx_esquema, file: i })
    }
  },
  watch: {
    pendingFile: function (val) {
      var obj = this
      if (val) {
        obj.get_db().then(function (db) {
          /* eslint-disable */
          /* La idea es crear algun tipo de manejo para las imagenes del servidor. Aun se encuentra incompleto */
          if (obj.$route.params.typex === 'local' || true) {
          /* eslint-enable */
            db.getAttachment(obj.pendingFile.idx, obj.pendingFile.file).then(function (att) {
              obj.$set(obj.loadedFiles, obj.pendingFile.file, window.URL.createObjectURL(att))
              // console.log(obj.loadedFiles)
              obj.pendingFile = null
            }).catch(function (err) {
              console.log(err)
            })
          } else {
            obj.xhr = new XMLHttpRequest()
            obj.xhr.open('GET', db.name + '/' + obj.idx + '/' + obj.pendingFile, true)
            obj.xhr.responseType = 'blob'
            setTimeout(function () { obj.xhr.abort() }, 5000)
            obj.xhr.onload = function () {
              // var img = new Image()
              var response = obj.xhr.response
              obj.$set(obj.loadedFiles, obj.pendingFile, window.URL.createObjectURL(response))
              obj.pendingFile = null
            }
            obj.xhr.send()
          }
        })
      } else {
        if (obj.pendingFiles.length > 0 && !obj.stop) {
          obj.pendingFile = obj.pendingFiles.pop()
        }
      }
    },
    vattachments_image: function (to, from) {
      if (to && to !== from) {
        for (var i in to) {
          this.addPendingFile({ idx: this.idx_image, file: i })
          /* if (!(i in from)) {
            this.addPendingFile({idx: this.idx_image, file: i})
          } */
        }
      }
    },
    vattachments_esquema: function (to, from) {
      if (to && to !== from) {
        for (var i in to) {
          this.addPendingFile({ idx: this.idx_esquema, file: i })
          /* if (!(i in from)) {
            this.addPendingFile({idx: this.idx_esquema, file: i})
          } */
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'get_db'
    ]),
    addPendingFile (id) {
      this.pendingFiles.push(id)
      // this.$set(this.pendingFiles, this.pendingFiles.length, id)
      if (this.pendingFile === null) {
        this.pendingFile = this.pendingFiles.pop()
      }
    }
  }
}
</script>
